import { CampaignTipo } from '../types';
import { CampaignStrategy } from './campaign-strategy';
import { DescontoAtingirMetaStrategy } from './desconto-atingir-meta.strategy';
import { BonificacaoProporcionalStrategy } from './bonificacao-proporcional.strategy';
import { DescontoStrategy } from './desconto.strategy';
import { BonificacaoFixaStrategy } from './bonificacao-fixa.strategy';
import { NotificacaoStrategy } from './notificacao.strategy';

const registry: Record<CampaignTipo, CampaignStrategy> = {
    DESCONTO: new DescontoStrategy(),
    BONIFICACAO_FIXA: new BonificacaoFixaStrategy(),
    BONIFICACAO_PROPORCIONAL: new BonificacaoProporcionalStrategy(),
    NOTIFICACAO: new NotificacaoStrategy(),
    DESCONTO_ATINGIR_META: new DescontoAtingirMetaStrategy(),
};

export const getCampaignStrategy = (
    tipo: string | CampaignTipo | undefined,
): CampaignStrategy | undefined => {
    if (!tipo) return undefined;
    return registry[tipo as CampaignTipo];
};

export type { CampaignStrategy } from './campaign-strategy';
export { DescontoAtingirMetaStrategy } from './desconto-atingir-meta.strategy';
export { BonificacaoProporcionalStrategy } from './bonificacao-proporcional.strategy';
export { DescontoStrategy } from './desconto.strategy';
export { BonificacaoFixaStrategy } from './bonificacao-fixa.strategy';
export { NotificacaoStrategy } from './notificacao.strategy';
